module.exports = __webpack_public_path__ + "static/media/logo.46a0a86c.png";